import { Dispatch } from '@reduxjs/toolkit';
import { setAccommodationBlockings, setAccommodationBlockingsLoading } from '../actions';
import { AppState } from '../store';

export function getAccommodationBlockings(): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    dispatch(setAccommodationBlockingsLoading(true));

    try {
      const data = await fetch(`${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/AccommodationBlocking`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const accommodationBlockings = await data.json();
      dispatch(setAccommodationBlockings(accommodationBlockings));
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setAccommodationBlockingsLoading(false));
    }
  };
}
